export default {
  VIDEO_PLAYLIST_FETCHED: 'VIDEO_PLAYLIST_FETCHED',
  VIDEO_PLAYLIST_LOAD: 'VIDEO_PLAYLIST_LOAD',
  VIDEO_PLAYLIST_TEMPLATES_FETCHED: 'VIDEO_PLAYLIST_TEMPLATES_FETCHED',
  VIDEO_PLAYLIST_TEMPLATES_LOAD: 'VIDEO_PLAYLIST_TEMPLATES_LOAD',
  VIDEO_PLAYLIST_DETAIL: 'VIDEO_PLAYLIST_DETAIL',
  VIDEO_PLAYLIST_BUTTON_LOAD: 'VIDEO_PLAYLIST_BUTTON_LOAD',
};
